import React, { useState } from 'react';
import { useAppDispatch } from 'store/hooks';

import * as api from 'api/methods';

import { showToast } from 'helpers/showToast';
import { getTranslation } from 'helpers/getTranslation';
import { getUnknownErrorMessage } from 'helpers/unknownErrorMessage';

import { createAdmin } from 'store/admins/actions';

import { useFetch } from 'hooks/useFetch';

import { convertDataToApi } from './AddAdmin.helpers';

import AddAdmin from './AddAdmin';

const AddAdminContainer = ({
  open,
  isRootAdmin,
  isSchool,
  schoolId,
  onClose,
  ...restProps
}: {
  open: any;
  isRootAdmin: any;
  isSchool: any;
  schoolId: string;
  onClose: any;
} & Record<string, any>) => {
  const [inviteLoading, setInviteLoading] = useState(false);

  const dispatch = useAppDispatch();

  const { data: schools } = useFetch(
    {
      defaultData: [],
      fetcher: api.getSchools,
      immediately: false,
      stopRequest: !open || !isRootAdmin || isSchool,
    },
    null,
    [open],
  );

  const handleInviteAdminClick = async (
    data: any,
    { resetForm }: { resetForm: any },
  ) => {
    setInviteLoading(true);

    try {
      await dispatch(
        createAdmin(convertDataToApi({ data, isRootAdmin, schoolId })),
      ).unwrap();

      onClose();
      resetForm();

      showToast({
        data: {
          variant: 'success',
          title: getTranslation('common.toast.admin_invited.title'),
          text: getTranslation('common.toast.admin_invited.text'),
        },
      });
    } catch (error) {
      console.warn(error);

      showToast({
        data: {
          variant: 'error',
          title: getTranslation('common.toast.error.title'),
          text: getUnknownErrorMessage(
            error,
            getTranslation('common.toast.error.text'),
          ),
        },
      });
    }

    setInviteLoading(false);
  };

  const schoolOptions = schools.map((school: any) => ({
    label: school.name,
    value: school.id,
  }));

  return (
    <AddAdmin
      {...restProps}
      open={open}
      inviteLoading={inviteLoading}
      isRootAdmin={isRootAdmin}
      isSchool={isSchool}
      schoolOptions={schoolOptions}
      onClose={onClose}
      onInviteAdminClick={handleInviteAdminClick}
    />
  );
};

export default React.memo(AddAdminContainer) as any;
